<template>
  <v-dialog v-model="dialog" max-width="720" scrollable>
    <v-card class="dialog-card">
      <v-toolbar flat class="dialog-toolbar" height="56">
        <div class="toolbar-icon-wrap mr-3">
          <v-icon color="primary" size="20">mdi-cash-check</v-icon>
        </div>
        <div class="toolbar-title-block">
          <div class="toolbar-title">Pago de Inscripción</div>
          <div class="toolbar-subtitle text-truncate">Seleccionado por la contadora</div>
        </div>
        <v-spacer />
        <v-btn icon small @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <div v-if="cargando" class="d-flex justify-center py-4">
          <v-progress-circular indeterminate color="primary" size="32" width="3" />
        </div>
        <div v-else-if="!pago" class="empty-box">
          No se pudo obtener el pago de inscripción.
        </div>
        <pago-inscripcion-card v-else :pago="pago" />
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-spacer />
        <v-btn small text color="primary" @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SolicitudCalificacionNivelacionService from '../../services/solicitud-calificacion-nivelacion.service';
import PagoInscripcionCard from '../../centralizador/components/PagoInscripcionCard.vue';

export default {
  name: 'DialogVerPagoInscripcion',
  components: { PagoInscripcionCard },
  data() {
    return {
      dialog: false,
      cargando: false,
      pago: null,
    };
  },
  methods: {
    abrir(pagosInscripcionId) {
      this.dialog = true;
      this.pago = null;
      this.cargarPago(pagosInscripcionId);
    },
    cerrar() {
      this.dialog = false;
      this.pago = null;
    },
    async cargarPago(pagosInscripcionId) {
      this.cargando = true;
      try {
        const { data } = await SolicitudCalificacionNivelacionService.obtenerPagoInscripcion(pagosInscripcionId);
        this.pago = data?.datos || null;
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || error.message || 'Error al obtener el pago de inscripción';
        this.$notify({ group: 'notifications', title: 'Error', text: mensaje, type: 'error' });
        this.cerrar();
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.dialog-toolbar {
  background: linear-gradient(135deg, #eef3ff 0%, #f8fafc 100%) !important;
  border-bottom: 1px solid #dce6f0;
}

.toolbar-icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.toolbar-title-block {
  overflow: hidden;
}

.toolbar-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a2640;
  line-height: 1.2;
}

.toolbar-subtitle {
  font-size: 11px;
  color: #6b7a8d;
}

.empty-box {
  font-size: 12px;
  color: #9ca3af;
  border: 1px dashed #dce6f0;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
}
</style>
